import script from "./PageMappingCategoryUrssafBrandEditionDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageMappingCategoryUrssafBrandEditionDetail.vue?vue&type=script&setup=true&lang=ts"

import "./PageMappingCategoryUrssafBrandEditionDetail.vue?vue&type=style&index=0&id=baaa868c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-baaa868c"]])

export default __exports__